import axios, { AxiosRequestConfig, AxiosResponse } from 'axios';
import { IApiListParams } from '@/types';
import { IAcceptMappingSolutionParams, IMappingProblemApiListResponse } from '@/types/mappingProblem';

export const mappingProblemList = (params: IApiListParams, config?: AxiosRequestConfig): Promise<AxiosResponse<IMappingProblemApiListResponse>> => {
    return axios.get('/api/mappingProblem/list', { ...config, params });
};

export const acceptMappingSolution = (params: IAcceptMappingSolutionParams): Promise<AxiosResponse<{ success: boolean }>> => {
    return axios.post('/api/mappingProblem/accept', params);
};
